module.exports = __webpack_public_path__ + "img/entebowloben.87394659.png";